module.exports = __webpack_public_path__ + "img/pc-character.9f18ae4e.webp";